type Breadcrumb = { name: string; path: string }

type ProductBreadcrumbsProps = {
  productName: string
  breadcrumbs: Breadcrumb[]
  toLocalizedPath: (path: string) => string
}

export const ProductBreadcrumbs = ({ productName, breadcrumbs, toLocalizedPath }: ProductBreadcrumbsProps) => {
  return (
    <nav className="flex min-w-0 flex-wrap items-center gap-2 text-sm text-slate-600" aria-label="Breadcrumb">
      <a href={toLocalizedPath('/')} className="font-medium text-slate-700 transition hover:text-cyan-700">
        Home
      </a>
      {breadcrumbs.map((crumb) => (
        <span key={crumb.path} className="inline-flex items-center gap-2">
          <span className="text-slate-400">/</span>
          <a href={toLocalizedPath(crumb.path)} className="font-medium text-slate-700 transition hover:text-cyan-700">
            {crumb.name}
          </a>
        </span>
      ))}
      <span className="inline-flex items-center gap-2">
        <span className="text-slate-400">/</span>
        <span className="break-words font-semibold text-slate-900">{productName}</span>
      </span>
    </nav>
  )
}
